var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 11.5373 21.3065 11.4608 21.0672 11.8568C19.9289 13.7406 17.8615 15 15.5 15C11.9101 15 9 12.0899 9 8.5C9 6.13846 10.2594 4.07106 12.1432 2.93276C12.5392 2.69347 12.4627 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.75C12.5858 8.75 12.25 8.41421 12.25 8C12.25 7.58579 12.5858 7.25 13 7.25H16C16.3033 7.25 16.5768 7.43273 16.6929 7.71299C16.809 7.99324 16.7448 8.31583 16.5303 8.53033L14.8107 10.25H16C16.4142 10.25 16.75 10.5858 16.75 11C16.75 11.4142 16.4142 11.75 16 11.75H13C12.6967 11.75 12.4232 11.5673 12.3071 11.287C12.191 11.0068 12.2552 10.6842 12.4697 10.4697L14.1893 8.75H13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.75C14.5858 2.75 14.25 2.41421 14.25 2C14.25 1.58579 14.5858 1.25 15 1.25H17C17.3033 1.25 17.5768 1.43273 17.6929 1.71299C17.809 1.99324 17.7448 2.31583 17.5303 2.53033L16.8107 3.25H17C17.4142 3.25 17.75 3.58579 17.75 4C17.75 4.41421 17.4142 4.75 17 4.75H15C14.6967 4.75 14.4232 4.56727 14.3071 4.28701C14.191 4.00676 14.2552 3.68417 14.4697 3.46967L15.1893 2.75H15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.75C19.5858 6.75 19.25 6.41421 19.25 6C19.25 5.58579 19.5858 5.25 20 5.25H22C22.3033 5.25 22.5768 5.43273 22.6929 5.71299C22.809 5.99324 22.7448 6.31583 22.5303 6.53033L21.8107 7.25H22C22.4142 7.25 22.75 7.58579 22.75 8C22.75 8.41421 22.4142 8.75 22 8.75H20C19.6967 8.75 19.4232 8.56727 19.3071 8.28701C19.191 8.00676 19.2552 7.68417 19.4697 7.46967L20.1893 6.75H20Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.3e213b7c576a01ced2dde1be3d2ab008.svg";
export { ForwardRef as ReactComponent };